export default __webpack_public_path__ + "static/Resources2-c8e0ef1ddd26b16f4779b2ee9f059ac9.mp4";